export const getDepartmentCodePrefix = (departmentName, maxLen = 2) => {
  if (!departmentName) return "";

  const cleaned = String(departmentName)
    .trim()
    .replace(/[^a-zA-Z\s]/g, " ")
    .replace(/\s+/g, " ")
    .toUpperCase();

  if (!cleaned) return "";

  const words = cleaned.split(" ").filter(Boolean);

  // Prefer initials for multi-word departments: "IT Purchase" -> "IP"
  if (words.length >= 2) {
    return words
      .map((w) => w[0])
      .filter(Boolean)
      .join("")
      .slice(0, maxLen);
  }

  // Single word: first letter + next meaningful consonant/letter (no duplicates)
  const word = words[0];
  const first = word[0] || "";
  if (maxLen <= 1) return first;

  const vowels = new Set(["A", "E", "I", "O", "U"]);
  let second = "";

  for (const ch of word.slice(1)) {
    if (!/[A-Z]/.test(ch)) continue;
    if (ch === first) continue;
    if (!vowels.has(ch)) {
      second = ch;
      break;
    }
  }

  if (!second) {
    for (const ch of word.slice(1)) {
      if (!/[A-Z]/.test(ch)) continue;
      if (ch === first) continue;
      second = ch;
      break;
    }
  }

  return `${first}${second || ""}`.slice(0, maxLen);
};
